import { createAction, props } from '@ngrx/store';

export const setTenantKey = createAction('[Tenant] Set Tenant Key', props<{ tenantKey: string }>());
export const updateTenantKey = createAction('[Tenant] Update Tenant Key', props<{ tenantKey: string }>());
export const clearTenantKey = createAction('[Tenant] Clear Tenant Key');
